import Vue from "vue";
import Router from "vue-router";
import {
    getTokenAndBasicUserInfo
} from "@/api/userOneID";
Vue.use(Router);

const router = new Router({
    routes: [{
            path: '/',
            name: 'home',
            component: () =>
                import ("@/pages/Index")
        },
        {
            path: "/auth",
            beforeEnter: async(to, from, next) => {
                // 从 UserOneID 跳转回来之后的逻辑处理
                const {
                    code
                } = to.query;
                const {
                    fromAcemap,
                    name = "home"
                } = JSON.parse(
                    decodeURI(to.query.context)
                );
                console.log("context转义:", fromAcemap, name);

                if (fromAcemap) {
                    const acemapURL =
                        process.env.NODE_ENV === "production" ?
                        "https://dataexpo.acemap.info/" :
                        "http://10.10.10.225:8183/#/";
                    window.location.replace(`${acemapURL}auth?${decodeURI(to.query)}`);
                }
                try {
                    const res = await getTokenAndBasicUserInfo(code);
                    let access_token = res.data.access_token
                    let realName = res.data.realName
                    let userId = res.data.userid
                    if (realName) {
                        localStorage.setItem('userName', realName)
                        localStorage.setItem('accessToken', access_token)
                        localStorage.setItem('userId', userId)
                    }
                } catch (err) {
                    console.log("ERROR", err);
                }
                next({
                    name
                });
                // 自动跳转至首页
            }
        },
        {
            path: '/ranking',
            name: 'ranking',
            component: () =>
                import ("@/pages/ranking")
        },
        {
            path: '/findmore',
            name: 'findmore',
            component: () =>
                import ("@/pages/Findmore")
        },
        {
            path: '/recommend',
            name: 'recommend',
            component: () =>
                import ("@/pages/recommend")
        },
        {
            path: '/map',
            name: 'map',
            component: () =>
                import ("@/pages/MapSearch")
        },
        {
            path: '/tiandi',
            name: 'tiandi',
            component: () =>
                import ("@/pages/MapSearch_tiandi_test")
        },
        {
            path: '/gaode',
            name: 'gaode',
            component: () =>
                import ("@/pages/MapSearch_gaode_test")
        },
        {
            path: '/map-main',
            name: 'mapMain',
            component: () =>
                import ("@/pages/MapSearch_TianDi")
        },
        {
            path: '/QA',
            name: 'QA',
            component: () =>
                import ("@/pages/QA")
        },
        {
            path: '/dataset',
            name: 'Dataset',
            component: () =>
                import ("@/pages/Dataset")
        },
        {
            path: '/visit',
            name: 'visit',
            component: () =>
                import ("@/pages/visit")
        },
        {
            path: '/details',
            name: 'Details',
            component: () =>
                import ("@/pages/DetailsPage")
        }
    ]
})

let startTime = Date.now()
let currentTime = ''
router.beforeEach((to, from, next) => {
    // 页面打开埋点
    // ddeEventTrackingLogPost({
    //     eventType: 1,
    //     utlogMap: {},
    // });

    if (to) {
        currentTime = Date.now()
        let stayTime = parseInt(currentTime - startTime)
            // 页面停留时间埋点
            // ddeEventTrackingLogPost({
            //     eventType: 3,
            //     utlogMap: {
            //         stayTime: stayTime
            //     },
            // });
        startTime = Date.now()
    }
    next()
})

export default router